export default "__VITE_PUBLIC_ASSET__4a03d7f6__"